import React from 'react';
import { Flex } from '../Flex/Flex';
import { Label } from '../Label/Label';
import { Radio } from '../Radio/Radio';
import { TabTriggerRadio } from './Tab.styled';
export const TabRadio = ({
  tab,
  isActive,
  onTabSelect
}) => {
  return React.createElement(TabTriggerRadio, {
    asChild: true,
    value: `tab-${tab.id}`,
    key: `tab-${tab.id}`
  }, React.createElement(Flex, {
    alignItems: 'center',
    mr: 2
  }, React.createElement(Label, {
    fontSize: '14px'
  }, React.createElement(Radio, {
    value: tab.id,
    checked: isActive === tab.id,
    name: tab.id,
    onChange: onTabSelect
  }), tab.text)));
};